import React, { useState } from 'react';
import { useSetAtom } from 'jotai';
import { IconButton, Menu, MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import KeyboardIcon from '@mui/icons-material/Keyboard';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';

import { cheatsheetAtom } from 'atoms/cheatsheetAtom';
import { onboardingOpenAtom } from 'atoms/onboardingAtom';

// ヘルプ導線。キーボードショートカット一覧（C2）と操作ガイドの再生（C1）の入口を集約する。
// いずれも既存の表示用 atom を開くだけで、新規の副作用は持たない。
export const HelpMenu: React.FC = () => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const setCheatsheetOpen = useSetAtom(cheatsheetAtom);
    const setTourOpen = useSetAtom(onboardingOpenAtom);
    const close = () => setAnchorEl(null);

    return (
        <>
            <IconButton
                color="inherit"
                aria-label="ヘルプ"
                title="ヘルプ"
                onClick={(e) => setAnchorEl(e.currentTarget)}
                sx={{ flexShrink: 0 }}
            >
                <HelpOutlineIcon />
            </IconButton>
            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={close}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                <MenuItem
                    onClick={() => {
                        setCheatsheetOpen(true);
                        close();
                    }}
                >
                    <ListItemIcon>
                        <KeyboardIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText primary="キーボードショートカット" secondary="?" />
                </MenuItem>
                <MenuItem
                    onClick={() => {
                        setTourOpen(true);
                        close();
                    }}
                >
                    <ListItemIcon>
                        <PlayCircleOutlineIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText primary="操作ガイドを再生" />
                </MenuItem>
            </Menu>
        </>
    );
};
